import { createApp } from 'vue'
import App from './App.vue'
import {Keyframes} from 'vue-keyframes';
// import '@fortawesome/fontawesome-free/css/all.css'
import 'font-awesome/css/font-awesome.min.css'
const app =createApp(App)
app.use(Keyframes)
app.mount('#app')
